<template>
  <button id="NUMBER_8" name="8" class="btn num-btn" data-vcode="NUMBER_8" aria-label="8 TUV">
    <div class="digit">8</div>
    <div class="letters">TUV</div>
  </button>
</template>
<script>
export default {};
</script>
